<template>
    <div class="page white_bg">

        <header class="pageHeader detailPageHeader white_bg bottomBorder101010" style="line-height: 46px;">
            <div class="flexLayout paddingH16">
                <div style="width: 16%">
                    <span class="icon leftAngleBracketIcon floatL" style="margin-top: 12px;" @click="back();"></span>
                </div>
                <div class="flexItem alignCenter font18r primaryTextColor bold hiddenOverflow"
                     style="height: 46px; ">
                    {{title}}
                </div>
                <div class="font14r alignRight" style="width: 16%">

                </div>
            </div>
        </header>

        <div class="body">
            <div class="generalPagePaddingH">
                <div class="formRow">
                    <div class="columnName">手机号</div>
                    <div class="columnValue">
                        <input type="text" class="inputbox block" v-model="formData.username"/>
                    </div>
                </div>
                <div class="formRow">
                    <div class="columnName">密码</div>
                    <div class="columnValue">
                        <input type="password" class="inputbox block" v-model="formData.password"/>
                    </div>
                </div>
                <div class="formRow">
                    <button @click="submit()">登录</button>
                </div>
            </div>
        </div><!-- end .body -->

    </div>
</template>

<script>
import shixunPagePart from '@/components/shixunApp/shixunPagePart';
import userApi from "@api/user";
import appHelper from "@util/appHelper";

const config = {
    name : 'login',
    title : '登录',
    description : '',
    apiConfig : {
        get : {
            url : '',
            dataColumnMapping : {
                // userName : 'name'
            }
        }
    }
};

export default {
    name: config.name,
    extends : shixunPagePart,
    components : {  },
    data () {
        return {
            title : config.title,
            description : config.description,
            apiConfig : config.apiConfig,
            formData : {
                username : '',
                password : ''
            }
        }
    },
    methods : {
        submit() {
            userApi.login({
                loginName: this.formData.username,
                password: this.formData.password
            }, (result) => {

                if (result.errorCode)
                {
                    appHelper.showHint(result.msg);
                    return;
                }

                if (result.data.isDisplayVerifyCode) {
                    appHelper.showHint('需要输入验证码');
                    return;
                }

                appHelper.showHint('登录成功');
                appHelper.goToPage('index')
            });
        }
    }
}
</script>

<style lang="scss" scoped>
.formRow {
    .columnName {
        color: #5B616C;
    }
    .columnValue {
        .inputbox {
            display: block;
            width: 100%;
            font-size: 16px;
            height: 27px;
            line-height: 27px;
            //border: none;
            background: transparent;
            color: hsla(0, 0%, 20%, 1);
            outline: none;
        }
        .inputbox::placeholder,
        .inputbox::-webkit-input-placeholder,
        .inputbox::-moz-placeholder,
        .inputbox::-ms-input-placeholder {
            color: hsla(220, 27%, 78%, 1);
        }
    }
}
</style>
